import { Pipe, PipeTransform } from '@angular/core';
import { DeviceShadow, DeviceStatus } from '../models/shadow/device-shadow';

@Pipe({ name: 'deviceInStatus' })
export class DeviceInStatusPipe implements PipeTransform {

  transform(value: DeviceShadow, desiredStatus: DeviceStatus): boolean {
    return value?.status === desiredStatus;
  }

}
